import React, { useContext } from 'react';
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink,Image } from '@react-pdf/renderer';
import { Button, useTheme, useMediaQuery } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import { Grid, Paper, Typography, Stack, Box } from "@mui/material";
import Hubballi from "./Hubballi-Regular.ttf"
import { Font } from '@react-pdf/renderer';
import installationCondition from "./installationCondition.json"
import deratingimages from "./Deratingimages.json"


function ReportComponent ({ results, inputData }){

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
   
  const activeResults = results?.activeResults
  const cableType = inputData?.cableType
  const deratingcondition = inputData?.deratingConditions
  const additionalderatingcondition = inputData?.additionalderatingConditions 
  const installation = inputData?.installationOption
  const installationArray = installationCondition?.[cableType]?.[installation];
  const installationreference = installationArray?.[1]
  const installationimage = installationArray?.[0]
const deratingconditionimage =
  deratingimages?.[cableType]?.[deratingcondition?.["Installation"]] ||
  deratingimages?.[cableType]?.[installation];  const installationOption = inputData.installationOption
  const earthResults = results?.Earth_Result
  const deratingresults = activeResults?.Derating
  const RCDinstalled = inputData?.rcdChecked
  const loadcurrent = inputData?.loadCurrent
  const deratingfactor = activeResults?.Derating?.[activeResults.Derating.length - 1]?.[1]?.[0];
  const maximum_operating_temp = results?.activeResults?.voltageDrop?.max_operating_temp
  const ambient_operating_temp = results?.activeResults?.voltageDrop?.ambient_operating_temp
  const operating_temperature = results?.activeResults?.voltageDrop?.operating_temperature
  const selectedPhase = inputData?.phase
  const lengthofrun = inputData?.lengthOfCable
  const PF = inputData?.powerFactor
  const voltage = inputData?.supplyVoltage
    const voltagepercentmax = inputData?.maxVoltageDrop
  const activetriptime = inputData?.activetriptime
  const earthtripcurrent = inputData?.earthtripcurrent
const supplyfaultlevelinput = inputData?.activefaultlevel

  // Extracting values
  const Active_cable_size = activeResults?.selectedCableSize;
  const Active_cable_mode = inputData?.activeCableSizingMode;
  const Circuit_capacity_derated = activeResults?.currentCarryingCapacity?.circuitRatingDerated;
  const Circuit_capacity = activeResults?.currentCarryingCapacity?.circuitRating;
  const spare_capacity = Math.round(activeResults?.currentCarryingCapacity?.spareCapacity * 100) / 100;
  const number_of_active_circuits = activeResults?.number_of_circuits;
  const current_carrying_cap_ok = activeResults?.currentCarryingCapacity?.ok;
  const current_carrying_cap_ref = activeResults?.currentCarryingCapacity?.current_capacity_ref;

  const Voltage_drop = Math.round(activeResults?.voltageDrop?.voltageDropCable * 100) / 100;
  const voltage_drop_percent = Math.round(activeResults?.voltageDrop?.voltageDropPercent * 100) / 100;
  const max_length_cable = Math.round(activeResults?.voltageDrop?.maxLengthOfCable * 100) / 100;
  const resistance_active = activeResults.voltageDrop?.resistancePerKm;
  const reactance_active = activeResults.voltageDrop?.reactancePerKm;
  const operating_temp_calculation = Math.round(activeResults?.voltageDrop?.operatingTempCalculated * 100) / 100;
  const voltage_drop_cap_ok = activeResults?.voltageDrop?.ok;
  const resistance_active_ref = activeResults.voltageDrop?.resistance_per_km_ref;
  const reactance_active_ref = activeResults.voltageDrop?.reactance_per_km_ref;

  const short_circuit_soure = activeResults?.shortCircuitCapacity?.faultLevelSupply;
  const short_circuit_load = Math.round(activeResults?.shortCircuitCapacity?.faultLevelLoad * 100) / 100;
  const K_value = activeResults?.shortCircuitCapacity?.KValue;
  const source_impedance = activeResults?.shortCircuitCapacity?.sourceImpedance;
  const total_impedance = activeResults?.shortCircuitCapacity?.totalImpedance;
  const short_circuit_capacity = Math.round(activeResults?.shortCircuitCapacity?.ICalculation * 100) / 100;
  const short_circuit_cap_ok = activeResults?.shortCircuitCapacity?.ok;
  const cablecrosssec = activeResults?.shortCircuitCapacity?.cablecrosssec;
  const K_value_ref = activeResults?.shortCircuitCapacity?.KValue_ref;
  const derating = activeResults?.Derating
  const shortcircuitfinaltemp = activeResults?.shortCircuitCapacity?.final_operating_temperature
  const shortcircuitinitialtemp = activeResults?.shortCircuitCapacity?.initial_operating_temperature

  const Earth_cable_size = earthResults?.Earth_cable_size;
  const max_operating_temp = earthResults?.max_operating_temp;

  const number_of_earth_circuit = earthResults?.number_of_earth_circuits;
  const earthCableSizingMode = inputData?.earthCableSizingMode;
  const earthRef = earthResults?.ref
  const Phase_voltage = Math.round(earthResults?.Phase_voltage* 100) / 100;
  const EFLcheck = earthResults?.Loop_impedance_check
  const ImpedanceEarth = Math.round(earthResults?.Impednace_earth* 10000) / 10000;
  const ImpedanceActive = Math.round(earthResults?.Impedance_active * 10000) / 10000;
  const Zint = Math.round(earthResults?.Z_int* 10000) / 10000;
  const Zext = Math.round(earthResults?.Z_ext* 10000) / 10000;
  const EFL = Math.round(earthResults?.Loop_impedance* 10000) / 10000;
  const earthfaultlevel =  inputData?.earthfaultlevel;
  const earthtriptime =  inputData?.earthtriptime;
  const earthfaultlevelcheck =  earthResults?.short_circuit_ok;
  const earthshortcircuitcap = Math.round(earthResults?.short_circuit_cap* 100) / 100;
  const kvalue = earthResults?.K;
  const K_value_refearth = earthResults?.K_value_ref;
  const Requiredloopimpidance = Math.round(earthResults?.Requiredloopimpidance* 100) / 100;
  const earth_Fault_level = Math.round(earthResults?.earth_Fault_level* 100) / 100;
  const initial_operating_temperature = Math.round(earthResults?.initial_operating_temperature* 100) / 100;

 Font.register({
  family: 'Hubballi',
  src: Hubballi,
});
 
const styles = StyleSheet.create({
      rowSplit: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 1,
  },
  leftTextContainer: {
    flex: 3,
    paddingRight: 10,
  },
  rightImageContainer: {
    flex: 1,
    alignItems: 'flex-end',
  },
  page: {
    padding: 40,
    fontFamily: 'Hubballi',
    backgroundColor: '#ffffff',
  },
  headingContainer: {
    marginBottom: 20,
    textAlign: 'center',
  },
  heading: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'left',
    color: '#333333',
    paddingBottom: 10,
    fontFamily: 'Hubballi',
  },
  section: {
    marginTop: 2,
    paddingBottom: 10,
    paddingTop: 10,
 
    borderTopWidth: 1,
    borderTopColor: '#ccc',

  },
  subheading: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 10,
    marginTop: 10
  },
  bodyText: {
    fontSize: 12,
    color: '#333',
    lineHeight: 1.4,
  },
    image: {
    width: 80,
    height: 80,
  },
});
 
 
 
 const MyDocument = () => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.headingContainer}>
        <Text style={styles.heading}>
          CABLE SIZE CALCULATION REPORT (AS3008:1.2)
        </Text>
      </View>
<Text style={styles.subheading}>CABLE SIZE</Text>
            <View style={styles.section}>
        
        <Text style={styles.bodyText}>
          Active Cable Size = {number_of_active_circuits} x {Active_cable_size} mm², Cable Type: {inputData.cableType.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())}/{inputData.conductor}/{inputData.insulation.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())}
        </Text>
                <Text style={styles.bodyText}>
          Neutral Cable Size = Same Size As Active
        </Text>
        <Text style={styles.bodyText}>
          Earth Cable Size = {number_of_earth_circuit} x {Earth_cable_size} mm², Cable Type: {inputData.earthconductor}/{inputData.insulation.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())} (Earth.ref: {earthRef})
        </Text>
      </View>


<Text style={styles.subheading}>INSTALLATION CONDITIONS</Text>
            <View style={styles.section}>
        
        <Text style={styles.bodyText}>
          Load Current = {loadcurrent} A at {PF} power factor
        </Text>
        <Text style={styles.bodyText}>
        Supply: {selectedPhase}, {selectedPhase === "3 - Phase AC" ? "Line to line voltage" : "Phase voltage"}: {voltage} V
        </Text>
        <View style={styles.rowSplit}>
        <View style={styles.leftTextContainer}>
            <Text style={styles.bodyText}>
            Installation Method : {installationOption} (Installation Ref AS3008.1.2:2017 {installationreference})
            </Text>
        </View>
        <View style={styles.rightImageContainer}>
            <Image style={styles.image} src={installationimage} />
        </View>
        </View>

                <View style={styles.rowSplit}>
        <View style={styles.leftTextContainer}>
         {Object.entries(deratingcondition).map(([key, value], index) => (
    <Text key={index} style={styles.bodyText}>
      {key}: {value}
    </Text>
  ))}
            {Object.entries(additionalderatingcondition).map(([key, value], index) => (
    <Text key={index} style={styles.bodyText}>
      {key}: {value}
    </Text>
  ))}
        </View>
            {deratingconditionimage && (
            <View style={styles.rightImageContainer}>
                <Image style={styles.image} src={deratingconditionimage} />
            </View>
            )}
        </View>


        <Text style={styles.subheading}>CURRENT CARRYING CAPACITY {current_carrying_cap_ok ? '(PASS)' : '(FAIL)'}</Text>
        
            <View style={styles.section}>
        
        <Text style={styles.bodyText}>
          Current Carrying Capacity = {Circuit_capacity} A (Reference: {current_carrying_cap_ref}) 
          </Text>
          <Text style={styles.bodyText}>
          Current Carrying Capacity (Derated) = {Circuit_capacity_derated} A
          </Text>
          <Text style={styles.bodyText}>
          Spare Capacity = {spare_capacity} A 
          </Text>
          <Text style={styles.bodyText}>
          Cable Operating Temperature: {operating_temp_calculation} Deg.C
        </Text>
        <Text style={styles.bodyText}>
        </Text>
      </View>


              <Text style={styles.subheading}>DERATING CONDITIONS</Text>
        
            <View style={styles.section}>
        
             {deratingresults.map((value, index) => (
    <Text key={index} style={styles.bodyText}>
      {value[0]}: {value[1][0]}, (Reference {value[1][1]})
    </Text>
  ))}
      </View>
      </View>

</Page>
<Page size="A4" style={styles.page}>
    <View>
            <Text style={styles.subheading}>VOLTAGE DROP REQUIREMENTS {voltage_drop_cap_ok ? '(PASS)' : '(FAIL)'}</Text>
        
            <View style={styles.section}>
        
        <Text style={styles.bodyText}>
          Active Cable Resistance (at {operating_temperature} Deg.C) = {resistance_active} ohms/km (Ref: {resistance_active_ref})
          </Text>
          <Text style={styles.bodyText}>
          Active Cable Reactance = {reactance_active} ohms/km (Ref: {reactance_active_ref})
          </Text>
          <Text style={styles.bodyText}>
          Length of Cable = {max_length_cable} m 
          </Text>
                    <Text style={styles.bodyText}>
          Maximum Allowed Voltage Drop = {voltagepercentmax} % 
          </Text>
        <Text style={styles.bodyText}>
        {selectedPhase === "3 - Phase AC" ? "Voltage Drop Per Phase" : "Voltage Drop"}: {Voltage_drop} V ({voltage_drop_percent} %)
        </Text>
        <Text style={styles.bodyText}>
        </Text>
      </View>


      
            <Text style={styles.subheading}> SHORT CIRCUIT TEMPERATURE RISE {short_circuit_cap_ok ? '(PASS)' : '(FAIL)'}</Text>
        
            <View style={styles.section}>
        
        <Text style={styles.bodyText}>
            Supply Fault Level: {short_circuit_soure} A for {activetriptime} s
          </Text>
          <Text style={styles.bodyText}>
          Fault Level At Load: {short_circuit_load} A
          </Text>
                    <Text style={styles.bodyText}>
          K Value: {K_value} (Ref: {K_value_ref})
          </Text>
        <Text style={styles.bodyText}>
          Short Circuit Capacity : {short_circuit_capacity} A for {activetriptime} s
          </Text>
      </View>


                  <Text style={styles.subheading}> EARTH CABLE SIZE CALCULATION ({earthRef})</Text>
        
        {earthCableSizingMode === "Automatic" && (
            <View style={styles.section}>       
        <Text style={styles.bodyText}>
            Total Active Area: {number_of_active_circuits} x {Active_cable_size} mm²
          </Text>
          <Text style={styles.bodyText}>
           Earth Cable Size Based On AS3000 Table 5.1: {number_of_earth_circuit} X {Earth_cable_size} mm² 
          </Text>
      </View>
        )}


                {earthCableSizingMode !== "Automatic" && (
            <View style={styles.section}>       
        <Text style={styles.bodyText}>
            Active Impedance = {ImpedanceActive} ohms
          </Text>
                  <Text style={styles.bodyText}>
            Earth Impedance = {ImpedanceEarth} ohms
          </Text>
                            <Text style={styles.bodyText}>
           Z Internal (Active Impedance + Earth Impedance) = {Zint} ohms
          </Text>
                                      <Text style={styles.bodyText}>
           Z External = {Zext} ohms
          </Text>
                                                <Text style={styles.bodyText}>
           Earth Fault Loop Impedance = {EFL} ohms
          </Text>
        <Text style={styles.bodyText}>
           Earth Fault Protection Setting = {earthtripcurrent} A
          </Text>
                  <Text style={styles.bodyText}>
           Maximum Allowed Fault Loop Impedance = {Requiredloopimpidance} ohms
          </Text>
                            <Text style={styles.bodyText}>
           RCD Installed = {RCDinstalled ? "Yes" : "No"}
          </Text>
          <Text style={styles.bodyText}>
            Earth Fault Level : {earthfaultlevel} A for {earthtriptime} s
          </Text>
                    <Text style={styles.bodyText}>
            Earth Fault Level Downstream : {earth_Fault_level} A 
          </Text>
                            <Text style={styles.bodyText}>
          K Value: {kvalue} (Ref: {K_value_refearth})
          </Text>
        <Text style={styles.bodyText}>
          Short Circuit Capacity : {earthshortcircuitcap} A for {earthtriptime} s
          </Text>
      </View>
        )}

 
      </View>

      </Page>

      {/* Add more report sections here */}
    
  </Document>
);


      
      return (

<PDFDownloadLink
  document={<MyDocument/>}
  fileName="Cable Report.pdf"
>
  {({ blob, url, loading, error }) =>
    error|loading ? (
      <Button
        variant="contained"
        color="primary"
        disabled
        startIcon={<DescriptionIcon />}
        sx={{
          borderRadius: "12px",
          fontFamily: "'Hubballi', sans-serif",
          fontSize: "1.1rem",
          padding: "0.6rem 1.2rem",
          textTransform: "none",
        }}
      >
        Loading document...
      </Button>
    ) : (

          <Button
      variant="contained"
      color="primary"
      // Only set the startIcon prop on non-mobile screens
      startIcon={!isMobile ? <DescriptionIcon /> : null}
      sx={{
        borderRadius: "12px",
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "1.1rem",
        textTransform: "none",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        // Style adjustments for the mobile icon-only button
        ...(isMobile && {
          minWidth: 'auto', // Allow the button to shrink to the icon's size
          padding: '0.6rem', // Apply equal padding
        }),
        // Original padding for the desktop button
        ...(!isMobile && {
          padding: "0.3rem 1.2rem",
        }),
      }}
    >
      {/* Conditionally render the icon for mobile or the text for desktop */}
      {isMobile ? <DescriptionIcon /> : "Download Report"}
    </Button>
    )
  }
</PDFDownloadLink>

    );

}

export default ReportComponent;


